// src/components/editor/EditorSidebar.jsx
import React from 'react';
import { Box, Button, Badge } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import DescriptionIcon from '@mui/icons-material/Description';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import AddBoxIcon from '@mui/icons-material/AddBox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BuildIcon from '@mui/icons-material/Build';
import PeopleIcon from '@mui/icons-material/People';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import { SAVE_STATUS_CONFIG } from '../common/SaveStatusIndicator';

const TABS = [
  // Two words, and the 148px strip is too narrow for them on one line — the
  // label wraps rather than being abbreviated, because "Story" or "Elements"
  // alone reads as a different feature.
  { id: 'navigation', label: 'Story Elements', Icon: HomeIcon },
  { id: 'file',       label: 'File',       Icon: DescriptionIcon },
  { id: 'format',     label: 'Format',     Icon: TextFieldsIcon },
  { id: 'insert',     label: 'Insert',     Icon: AddBoxIcon },
  { id: 'view',       label: 'View',       Icon: VisibilityIcon },
  { id: 'tools',      label: 'Tool',       Icon: BuildIcon },
  { id: 'collab',     label: 'Collab',     Icon: PeopleIcon },
  { id: 'goals',      label: 'Goal',       Icon: TrackChangesIcon },
];

const EditorSidebar = ({ activePanel, onPanelClick, saveStatus }) => {
  return (
    <Box className="editor-sidebar-vertical">
      {TABS.map(({ id, label, Icon }) => {
        const icon = <Icon className="sidebar-vertical-icon" />;
        // Passive save-status dot on the File tab so it's visible without
        // opening the panel — writers rarely have it open mid-session.
        // Hidden in the steady "saved" state so it only draws the eye when
        // something actually needs attention.
        const showBadge = id === 'file' && saveStatus && saveStatus !== 'saved';
        const badgeColor = showBadge ? SAVE_STATUS_CONFIG[saveStatus]?.color : undefined;

        return (
          <Button
            key={id}
            className={`sidebar-vertical-button ${activePanel === id ? 'active' : ''}`}
            onClick={() => onPanelClick(id)}
          >
            {showBadge ? (
              <Badge
                variant="dot"
                sx={{ '& .MuiBadge-dot': { backgroundColor: badgeColor, top: 2, right: 2 } }}
              >
                {icon}
              </Badge>
            ) : (
              icon
            )}
            <span className="sidebar-vertical-label">{label}</span>
          </Button>
        );
      })}
    </Box>
  );
};

export default EditorSidebar;
